<template>
  <div>
    <Form :model="basicModel" class="inputForm labelForm" ref="financilForm" :rules="basicRules"> 
            <h3>
                {{$t('verifyTitle3')}}
            </h3>
            
            <FormItem prop="initialDeposit" class="item3 " :label='$t("initialDepositCurrency")'>
                <effect-select  v-model="basicModel.initialDeposit" :options='moneyOptions' :isLanguage='true' :isLabel="true"></effect-select>
            </FormItem>
            <FormItem prop="initialDepositCurrency" class="item3 nolabel" >
                <effect-select  :label='$t("currencyType")'  v-model="basicModel.initialDepositCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="employmentStatus" :class="[basicModel.employmentStatus == '2' || basicModel.employmentStatus == '4' || basicModel.employmentStatus == '5'?'itemLast':'item3' ]" :label='$t("employmentStatus")'>
                <effect-select @selectChange="selectChange"  v-model="basicModel.employmentStatus" :options='EmploymentOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem  prop="nameOfEmployer" class="item3 " :label='$t("nameOfEmployer")' v-if="basicModel.employmentStatus == '1' ">
                <effect-input :label='$t("basicLast")'  v-model="basicModel.nameOfEmployer" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="positionHold" class="item3 last" :label='$t("positionHold")' v-if="basicModel.employmentStatus == '1' ">
                <effect-input :label='$t("basicLast")'  v-model="basicModel.positionHold" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem prop="industry" class="item3" :label='$t("industry")' v-if="basicModel.employmentStatus == '3' || basicModel.employmentStatus == '1' ">
                <effect-select   v-model="basicModel.industry" :options='industryOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="yearlyIncome" :class="['item3 nolabel',basicModel.employmentStatus == '3' ? 'last':''] " v-if="basicModel.industry == '15' && (basicModel.employmentStatus == '3' || basicModel.employmentStatus == '1')">
                <effect-input :label='$t("basicLast")' :placeholder='$t("typein")'  v-model="basicModel.yearlyIncome" :isLabel="true"></effect-input>
            </FormItem> 
            <FormItem prop="timeWithCurrnetEmployer" :class="['item3',basicModel.industry == '15'? 'last':'']" :label='$t("timeWithCurrnetEmployer")' v-if="basicModel.employmentStatus == '1' ">
                <effect-select  v-model="basicModel.timeWithCurrnetEmployer" :options='timeOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem  prop="source" :class="['notopthreelabel',basicModel.source == '5'?'item3':'itemLast']" :label='$t("source")'>
                <effect-select  v-model="basicModel.source" :options='fromOptions' :isLanguage='true' :isLabel="true"></effect-select>
            </FormItem>
            <FormItem prop="purpose" class="item3 notopthreelabel" v-if="basicModel.source == '5'">
                <effect-input  :label='$t("basicLast")'  v-model="basicModel.purpose" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem prop="annualIncome" class="item3 " :label='$t("annualIncomeCurrency")'>
                <effect-select   v-model="basicModel.annualIncome" :options='moneyOptions2' :isLanguage='true' :isLabel="true"></effect-select>
            </FormItem>
            <FormItem prop="annualIncomeCurrency" class="item3 nolabel" >
                <effect-select :label='$t("currencyType")'  v-model="basicModel.annualIncomeCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="netWorth" class="item3 nolabel" :label='$t("netWorthCurrency")'>
                <effect-select  v-model="basicModel.netWorth" :options='moneyOptions2' :isLanguage='true' :isLabel="true"></effect-select>
            </FormItem>
            <FormItem prop="netWorthCurrency" class="item3 nolabel" >
                <effect-select :label='$t("currencyType")'  v-model="basicModel.netWorthCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            
            <FormItem prop="riskCapital" class="item3 " :label='$t("riskCapitalCurrency")'>
                <effect-input :label='$t("basicLast")'  :placeholder='$t("typein")'  v-model="basicModel.riskCapital" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem prop="riskCapitalCurrency" :class="['item3',lang == 'en'? 'notwolabel':'nolabel']" >
                <effect-select :label='$t("currencyType")' v-model="basicModel.riskCapitalCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            
            <h3 v-if="basicModel.employmentStatus == '3' ">
                {{$t('studentIncome')}}
            </h3>
            <FormItem  prop="employmentType" class="item3" :label='$t("durationLengthPeriod1")' v-if="basicModel.employmentStatus == '3' ">
                <effect-input :label='$t("basicLast")'  :placeholder='$t("typein")' v-model="basicModel.employmentType" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="durationLengthPeriod" class="item3" :label='$t("durationLengthPeriod2")' v-if="basicModel.employmentStatus == '3' ">
                <effect-select  :options='PeriodOptions'  v-model="basicModel.durationLengthPeriod" :isLabel="true"></effect-select>
            </FormItem>
            <FormItem prop="turnOver" class="item3 " :label='$t("Turnover")'  v-if="basicModel.employmentStatus == '3' ">
                <effect-input :label='$t("basicLast")'  v-model="basicModel.turnOver" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem prop="turnOverCurrency" class="item3 nolabel" v-if="basicModel.employmentStatus == '3' ">
                <effect-select  :label='$t("currencyType")'  v-model="basicModel.turnOverCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="platformRequested" class="item3 " :label='$t("platformRequested")'>
                <effect-select  v-model="basicModel.platformRequested" :options='apiOptions' :isLanguage='true' :isLabel="true"></effect-select>
            </FormItem>
            <FormItem  prop="requestCurrency" class="item3 nolabel" >
                <effect-select :label='$t("currencyType")'  v-model="basicModel.requestCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true"></effect-select>
            </FormItem>
            
            <!-- <FormItem prop="yearlyIncomeCurrency" class="item3" :label='$t("Annualincome")' v-if="basicModel.employmentStatus == '3' ">
                <effect-select  v-model="basicModel.yearlyIncomeCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem>
            <FormItem prop="yearlyIncome" class="item3 nolabel" v-if="basicModel.employmentStatus == '3' ">
                <effect-input :label='$t("basicLast")'  v-model="basicModel.yearlyIncome" :isLabel="true"></effect-input>
            </FormItem> -->
            <!-- <h3>
                {{$t('verifyTitle4')}}
            </h3>
            <FormItem  prop="bankName" class="item3 " :label='$t("bankName")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.bankName" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="bankAccountName" class="item3 " :label='$t("bankAccountName")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.bankAccountName" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="bankAddress" class="item3 last" :label='$t("bankAddress")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.bankAddress" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="bankCountry" class="item3 " :label='$t("bankCountry")'>
                <effect-select   v-model="basicModel.bankCountry" :options='countryList' :isLabel="true" :filterable="filterable"></effect-select>
                <!-- <effect-input :label='$t("basicLast")'  v-model="basicModel.bankCountry" ></effect-input> -->
             <!--</FormItem>
            <FormItem  prop="iban" class="item3 " :label='$t("iban")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.iban" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="swift" class="item3 last" :label='$t("swift")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.swift" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="accountNumber" class="item3 " :label='$t("accountNumber")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.accountNumber" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="sortCode" class="item3 " :label='$t("sortCode")'>
                <effect-input :label='$t("basicLast")'  v-model="basicModel.sortCode" :isLabel="true"></effect-input>
            </FormItem>
            <FormItem  prop="accountCurrency" class="item3 last" :label='$t("accountCurrency")'>
                 <effect-input :label='$t("basicLast")'  v-model="basicModel.accountCurrency" :isLabel="true"></effect-input> -->
               <!-- <effect-select :label='$t("currencyType")'  v-model="basicModel.accountCurrency" :options='currencyOptions' :isLanguage='true' :isLabel="true" ></effect-select>
            </FormItem> -->
            <FormItem class="itemBtns">
                <Button type="primary" class="formBtn"  @click="back">{{$t('back')}}</Button>
                <Button type="primary" class="formBtn"  @click="next">{{$t('next')}}</Button>
            </FormItem>
    </Form>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import EffectInput from '@/components/EffectInput.vue';
import EffectSelect from '@/components/EffectSelect.vue';
import Loading from '@/components/Loading.vue';



export default {
  name: 'Home',
  components: {
    EffectInput, 
    EffectSelect,
    Loading

  },
  data(){
    return{
        loading:false,
        basicModel:{
            initialDepositCurrency: "",
            initialDeposit: "",
            purpose: "",
            source: "",
            requestCurrency: "",
            platformRequested: "",
            employmentStatus: "",
            nameOfEmployer: "",
            positionHold: "",
            industry: "",
            timeWithCurrnetEmployer: "",
            employmentType:'',
            durationLengthPeriod: "",
            annualIncomeCurrency: "",
            annualIncome: "",
            netWorthCurrency: "",
            netWorth: "",
            riskCapitalCurrency: "",
            riskCapital: "",
            turnOverCurrency: "",
            turnOver: "",
            yearlyIncomeCurrency: "",
            yearlyIncome:"",
            bankName: "",
            bankAccountName:"",
            bankAddress: "",
            bankCountry: "",
            iban:"",
            swift: "",
            accountNumber: "",
            sortCode: "",
            accountCurrency: ""
        },
        basicRules: {
            initialDepositCurrency: [
                { required: true, message:this.$t('fieldError') , trigger: 'change' },
            ],
            initialDeposit: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            purpose: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            source: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            requestCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            platformRequested: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            employmentStatus: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            nameOfEmployer: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            positionHold: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            industry: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            timeWithCurrnetEmployer: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            employmentType: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            durationLengthPeriod: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            annualIncomeCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            annualIncome: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            netWorthCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            netWorth: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            riskCapitalCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            riskCapital: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
                { pattern: /^(\-|\+)?\d+(\.\d+)?$/, message: this.$t('numdiancheck'), trigger: 'blur' }
            ],
            turnOverCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            turnOver: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            yearlyIncomeCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            yearlyIncome: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            bankName: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            bankAccountName: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            bankAddress: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            bankCountry: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            iban: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            swift: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            accountNumber: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            sortCode: [
                { required: true, message: this.$t('fieldError') , trigger: 'blur' },
            ],
            accountCurrency: [
                { required: true, message: this.$t('fieldError') , trigger: 'change' },
            ],
            
        },
        currencyOptions:[
            {
                value:'1',
                label:'USD'
            },
            {
                value:'2',
                label:'EUR'
            },
            {
                value:'3',
                label:'GBP'
            }
        ],
        moneyOptions:[
            {
                value:'1',
                label:'00000-20,000'
            },
            {
                value:'2',
                label:'20,001-50,000'
            },
            {
                value:'3',
                label:'50,001-150,000'
            },
            {
                value:'4',
                label:'150,001-250,000'
            },
            {
                value:'5',
                label:'250,001-500,000'
            },
            {
                value:'6',
                label:'500,001 +'
            }
        ],
        moneyOptions2:[
            {
                value:'1',
                label:'money1'
            },
            {
                value:'2',
                label:'money2'
            },
            {
                value:'3',
                label:'money3'
            },
            {
                value:'4',
                label:'money4'
            },
            {
                value:'5',
                label:'money5'
            }
        ],
        timeOptions:[
            {
                value:'1',
                label:'timeyear1'
            },
            {
                value:'2',
                label:'timeyear2'
            },
            {
                value:'3',
                label:'timeyear3'
            },
            {
                value:'4',
                label:'timeyear4'
            },
            {
                value:'5',
                label:'timeyear5'
            }
        ],
        yearOptions:[],
        fromOptions:[
            {
                value:'1',
                label:'income'
            },
            {
                value:'2',
                label:'Savings'
            },
            {
                value:'3',
                label:'Inheritance'
            },
            {
                value:'4',
                label:'Investments'
            },
            {
                value:'6',
                label:'gifts'
            },
            {
                value:'7',
                label:'saleofproperty'
            },
            {
                value:'5',
                label:'Other'
            },
        ],
        industryOptions:[
            {
                value:'1',
                label:'Clothing'
            },
            {
                value:'2',
                label:'Computer'
            },
            {
                value:'3',
                label:'Construction'
            },
            {
                value:'4',
                label:'Consultancy'
            },
            {
                value:'5',
                label:'Electronics'
            },
            {
                value:'6',
                label:'Entertainment'
            },
            {
                value:'7',
                label:'Financial'
            },
            {
                value:'8',
                label:'Food'
            },
            {
                value:'9',
                label:'Health'
            },
            {
                value:'10',
                label:'IT_services'
            },
            {
                value:'11',
                label:'Non_profit'
            },
            {
                value:'12',
                label:'Retail'
            },
            {
                value:'13',
                label:'Services'
            },
            {
                value:'14',
                label:'Travel'
            },
            {
                value:'15',
                label:'Other'
            },
        ],
        apiOptions:[
            {
                value:'1',
                label:'MetaTrader'
            },
            {
                value:'2',
                label:'API'
            },
        ],
        EmploymentOptions:[
            {
                value:'1',
                label:'Employed'
            },
            {
                value:'2',
                label:'Unemployed'
            },
            {
                value:'3',
                label:'Self_Employed'
            },
            {
                value:'4',
                label:'Retired'
            },
            {
                value:'5',
                label:'Student'
            },
        ],
        PeriodOptions:[
            {
                value:'1',
                label:'periodYear1'
            },
            {
                value:'2',
                label:'periodYear2'
            },
            {
                value:'3',
                label:'periodYear3'
            },
            {
                value:'4',
                label:'periodYear4'
            },
        ],
        countryList:[],
        phoneList:[],
        filterable:true,

    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    // watch:{
    //     'basicModel.employmentStatus'(val){
    //         this.basicModel.industry = ''
    //     }
    // },
    created(){
        this.getCountry()
        this.getData()
        // console.log(this.userInfo)
    },
    methods:{
        getData(){
            this.$axios.get('/api/UserQuestion/FinancialInformation')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    this.basicModel = Object.assign(this.basicModel,res.data.obj)
                    this.$refs.financilForm.fields.forEach((v,j) => {
                        // console.log(v,j)
                        v.validateDisabled = true
                        v.validateMessage = ''
                        v.validateState = ''
                    })
                    
                    // console.log(this.basicModel)
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => this.$Message.error(err.data.msg))
        },
        getCountry(){
            this.countryList = []
            this.$axios.get('/api/CreateRealAccount/Index')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString()
                        }
                        if(this.lang == 'zh'){
                            data.label = e.nameCN
                        }else{
                            data.label = e.name
                        }
                        this.countryList.push(data)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        next(){
            this.$refs.financilForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$axios.post('/api/UserQuestion/FinancialInformation', this.basicModel)
                    .then(async (res) => {
                        console.log(res)
                        if(res.data.status == 1){
                            this.$Message.success(this.$t('saveSucccess'))
                            this.$emit('saveSteps',2)
                            this.$emit('changeSteps',2)
                            
                            // this.$Message.success(this.$t('loginsuccess'))
                            // this.$store.commit('setToken', res.data.obj.token)
                            // this.$store.commit('setUserInfo', res.data.obj.userInfo)
                            // this.$router.push({ path:'/myAccount'})
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                } else {
                    // this.$Message.error('Fail!');
                }
            })
        },
        back(){
            this.$emit('changeSteps',0)
        },
        selectChange(){
            this.basicModel.industry = ''
            this.$refs.financilForm.fields.forEach((v,j) => {
                // console.log(v,j)
                v.validateDisabled = true
                v.validateMessage = ''
                v.validateState = ''
            })
        }
    }
}
</script>
<style lang="less">
.verify{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    .content_wrapper{
        background-color: #f9fafb;
        border: 1px solid #f0f0f0;
        padding-top: 100px;
        .activate-process{
            position: relative;
            width: 60%;
            height: 3px;
            margin: 0px auto 110px;
            text-align: center;
            background-color: #e5e5e5;
            .process-item{
                position: absolute;
                top: -18px;
                left: 0px;
                transform: translateX(-50%);
                color: #332c2b;
                white-space: nowrap;
                span{
                    display: inline-block;
                    width: 34px;
                    height: 34px;
                    margin-bottom: 22px;
                    line-height: 34px;
                    color: #332c2b;
                    font-size: 14px;
                    background-color: #f5f5f5;
                    border: 1px solid #e5e5e5;
                    border-radius: 50%;
                    font-family: 'Montserrat-Regular';
                    cursor: pointer;
                }
                b{
                    font-weight: normal;
                }
            }
            .left25{
                left: 25%;
            }
            .left50{
                left: 50%;
            }
            .left75{
                left: 75%;
            }
            .left100{
                left: 100%;
            }
            .active,
            .complete,
            .finished{
                top: -24px;
                span{
                    width: 48px;
                    height: 48px;
                    margin-bottom: 14px;
                    font-size: 18px;
                    line-height: 48px;
                    background-color: #e32b3a;
                    border-color: #e32b3a;
                    color: #fff;
                    
                }
            }
            .active::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 50%;
                width: 72px;
                height: 3px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            .finished::after{
                content: "";
                position: absolute;
                z-index: -1;
                top: 24px;
                left: 70%;
                width: 160px;
                height: 4px;
                margin-left: 14px;
                background-color: #e32b3a;
            }
            
        }
    }
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
    .ivu-form-item{
        width: 48%;
    }
    
    .inputForm{
        h3{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        h3::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        .item4{
            width: 24%;
        }
        .item3{
            width: 32%;
        }
        .itemLast{
            width: 32%;
            margin-right: 40%;
        }
    }
}
</style>
